import { DateTime } from 'luxon';

export const convertDateTimeForRequest = (currentDateTime) => {
    return DateTime.fromISO(currentDateTime, { setZone: true })
        .toFormat('yyyy-MM-dd HH:mm:ss');
};